export default __webpack_public_path__ + "static/media/sweetBiscuits.99862967.jpg";